import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import React, { memo } from 'react';

import { styles as listingCardStyles } from './ListingCard';

const styles = {
  big: { fontSize: '1rem', lineHeight: 1.6 },
  med: { fontSize: '16px', lineHeight: 1.15 },
  small: { fontSize: '14px', lineHeight: 1.15 },
};

const ListingCardSkeletonComponent = ({ cardMediaHeight = 200 }) => {
  return (
    <Card sx={listingCardStyles.card}>
      <CardMedia sx={listingCardStyles.cardMedia}>
        <Skeleton height={cardMediaHeight} variant="rectangular" width="100%" />
      </CardMedia>
      <CardContent component={Grid} container sx={listingCardStyles.cardContent}>
        <Grid size={12} sx={listingCardStyles.cardContentItem}>
          <Skeleton sx={styles.big} variant="text" width="60%" />
          <Skeleton sx={styles.big} variant="text" width="25%" />
        </Grid>
        <Grid size={12} sx={listingCardStyles.cardContentItem}>
          <Skeleton sx={styles.med} variant="text" width="55%" />
          <Skeleton sx={styles.med} variant="text" width="20%" />
        </Grid>
        <Grid size={12} sx={listingCardStyles.cardContentItem}>
          <Skeleton sx={styles.small} variant="text" width="50%" />
        </Grid>
      </CardContent>
    </Card>
  );
};

const ListingCardSkeleton = memo(ListingCardSkeletonComponent);
ListingCardSkeleton.displayName = 'ListingCardSkeleton';

export default ListingCardSkeleton;
